import { Component, Input, ViewEncapsulation } from '@angular/core';

import { EmailButtonComponent } from '../../components/email-button/email-button.component';
import { EmailLayoutComponent } from '../../components/email-layout/email-layout.component';
import { EmailLinkComponent } from '../../components/email-link/email-link.component';
import { EmailMarginComponent } from '../../components/email-margin/email-margin.component';
import { EmailMessageHeaderComponent } from '../../components/email-message-header/email-message-header.component';
import { EmailRecruiteeLogoComponent } from '../../components/email-recruitee-logo/email-recruitee-logo.component';
import { EmailTextComponent } from '../../components/email-text/email-text.component';
import { EmailMailgunIfDirective } from '../../directives/email-mailgun-if.directive';
import { SsrMarkToUnwrapDirective } from '../../directives/ssr-markto-unwrap.directive';
import { WrappedValue } from '../../mailgun/wrap-value';

@Component({
  standalone: true,
  selector: 'email-event-notification-template',
  styleUrls: ['../../global-styles.less', './event-notification.component.less'],
  templateUrl: './event-notification.component.html',
  imports: [
    EmailMarginComponent,
    EmailLayoutComponent,
    EmailRecruiteeLogoComponent,
    EmailMessageHeaderComponent,
    EmailTextComponent,
    EmailButtonComponent,
    EmailLinkComponent,
    EmailMailgunIfDirective,
  ],
  hostDirectives: [SsrMarkToUnwrapDirective],
  encapsulation: ViewEncapsulation.None,
})
export class EventNotificationTemplateComponent {
  @Input({ required: true }) public data: WrappedValue<EventNotificationTemplateData>;
}

export type EventNotificationTemplateData = {
  title: string;
  time: {
    title: string;
    duration_html: string;
    timezone: string;
  };
  interviewers: {
    title: string;
    body: string;
  };
  candidate?: {
    title: string;
    body: string;
  };
  link: {
    title: string;
    url: string;
  };
  public_note?: {
    title: string;
    body: string;
  };
  private_note?: {
    title: string;
    body: string;
  };
  footer?: string;
};

export const EventNotificationTemplateMocks: EventNotificationTemplateData[] = [
  {
    title: 'On-site interview',
    time: {
      title: 'When',
      duration_html: '<b>Thrusday</b>, 28 September 2017 at <b>8:00 - 9:00</b>',
      timezone: 'America/New York (-4:00)',
    },
    interviewers: {
      title: 'Interviewers',
      body: 'Jacek Buczek, Melon Plusk, Kate Watson',
    },
    candidate: {
      title: 'Candidate',
      body: 'Bruce Banner',
    },
    link: {
      title: 'Link',
      url: 'http://recruitee.com',
    },
    public_note: {
      title: 'Note',
      body: 'If you have any questions please send us email or message to 918-182-123',
    },
    private_note: {
      title: 'Private note',
      body: 'Lives outside Amsterdam. High salary expectations.',
    },
    footer: 'test_footer',
  },
];
